<script setup>
import { ref } from 'vue';
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import SentSms from './SentSms.vue';
import Twilio from './Twilio.vue';

const provider = ref('sent');
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="sent">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.SENT') }}
          </option>
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
          </option>
          <option value="bandwidth">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH') }}
          </option>
        </select>
      </label>
    </div>
    <SentSms v-if="provider === 'sent'" />
    <Twilio v-else-if="provider === 'twilio'" type="sms" />
    <BandwidthSms v-else />
  </div>
</template>
